





































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { IFieldInfoListItem } from '@/types/component';
import ShowImg from '@/components/show-img/index.vue';
import { repaireRecordExamine } from '@/api/exception-management/index';
import { enterOrExit } from '@/api/exception-management/index';
@Component({
  name: 'HandDetail',
  components: { ShowImg }
})
export default class HandDetail extends Vue {
  // 是否审核
  @Prop({ type: Boolean, default: false })
  isReview!: boolean;
  // 数据
  @Prop({ type: Object, default: {} })
  formData!: Record<string, any>;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  reviewDescription = '';
  formFields = [
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'plate',
      label: '车牌号'
    },
    {
      prop: 'channelTypeName',
      label: '通道类型'
    },
    {
      prop: 'enterChannelName',
      label: '通道名称'
    },
    {
      prop: 'revisePlateNum',
      label: '修正位数'
    },
    {
      prop: 'beforePlate',
      label: '修正前车牌'
    },
    {
      prop: 'afterPlate',
      label: '修正后车牌'
    },
    {
      prop: 'beforeCarTypeName',
      label: '修正前车型'
    },
    {
      prop: 'afterCarTypeName',
      label: '修正后车型'
    },
    {
      prop: 'reviseTime',
      label: '修正时间'
    },
    {
      prop: 'issuedStatusName',
      label: '同步状态'
    },
    {
      prop: 'reviseFromName',
      label: '操作来源'
    },
    {
      prop: 'operater',
      label: '操作员'
    }
  ];
  formReviewFields = [
    {
      prop: 'reviewStatusName',
      label: '审核状态'
    },
    {
      prop: 'reviewTime',
      label: '审核时间'
    },
    {
      prop: 'reviewDescription',
      label: '审核意见'
    },
    {
      prop: 'reviewer',
      label: '审核人'
    }
  ];
  loadingFlag: boolean = false;
  toDeatilFlag: boolean = false;
  //
  onSubmit() {
    if (this.isReview) {
      const json = {
        id: this.formData.pkReviseId,
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '01',
        userId: this.formData.userId,
        orderId: this.formData.orderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  //
  cacnelItem() {
    if (this.isReview) {
      const json = {
        id: this.formData.pkReviseId,
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '00',
        // userId: this.formData.userId,
        orderId: this.formData.orderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  onCancel() {
    this.$emit('cancel');
  }
  //审核
  async reviewItem(json: {
    id: any;
    parkId: any;
    reviewDescription: string;
    reviewStatus: string;
    userId?: any;
    orderId: any;
  }) {
    try {
      if (this.loadingFlag) return;
      this.loadingFlag = true;
      await repaireRecordExamine(json);
      this.$message.success('意见提交成功');
      this.$emit('create');
    } catch (e) {
      this.$message.error(e.msg || '系统繁忙请稍后再试');
    } finally {
      this.loadingFlag = false;
    }
  }
  //去停车详情或订单详情
  async MoreDetail(record: { orderId: any }) {
    if (record) {
      try {
        if (this.toDeatilFlag) return;
        this.toDeatilFlag = true;
        const { data } = await enterOrExit({ orderId: record.orderId });
        if (!data) return this.$message.error('暂无停车记录详情');
        //在场
        if (data == '00') {
          this.$emit('create');
          return this.$router.push({ name: 'ENTER_CAR_DETAIL', params: { pkOrderId: record.orderId, from: '01' } });
        }
        //出场
        if (data == '01') {
          this.$emit('create');
          return this.$router.push({
            name: 'PARKING_RECORD_DETAIL',
            params: { pkOrderId: record.orderId, from: '01' }
          });
        }
      } catch (e) {
        this.$message.error((e && e.msg) || '系统异常请稍后再试');
      } finally {
        this.toDeatilFlag = false;
      }
    }
  }
}
